export default "__VITE_ASSET__BFNvQC$T__"